module.exports = __webpack_public_path__ + "img/18-Ball-min.dd018683.png";